import React from 'react';
import './Projects.css';

function Projects() {
  const projects = [
    {
      id: 1,
      image: './assets/project-1.jpeg',
      title: 'Vyapar AI Assistant',
      description: 'AI-powered business assistant for local shops with multilingual support, business analytics, and growth strategies based on current market trends.',
      tech: ['React', 'Spring Boot', 'Tailwind CSS', 'Gemini AI', 'ElevenLabs', 'MySQL'],
      features: ['Business Overview', 'Local Language Support', 'Market Analysis', 'Voice Assistant', 'Growth Strategies'],
      status: 'Live',
      github: 'https://github.com/pc-daukiya',
      demo: 'https://vyaparai.ecellecb.com/overview'
    },
    {
      id: 2,
      image: './assets/project-2.jpeg',
      title: 'SplitBill DApp',
      description: 'Decentralized bill splitting application with Algorand blockchain integration, OCR for receipts, and voice reminders.',
      tech: ['React', 'Tailwind CSS', 'Spring Boot', 'Algorand', 'Gemini AI', 'ElevenLabs', 'MySQL', 'Auth0'],
      features: ['Blockchain Wallet Integration', 'Bill Splitting', 'Image to Text OCR', 'Voice Reminders', 'Group Management'],
      status: 'Live',
      github: 'https://github.com/pc-daukiya',
      demo: 'https://resilient-hamster-413e5d.netlify.app/dashboard'
    },
    {
      id: 3,
      image: './assets/project-3.png',
      title: 'Fitness PlayGround',
      description: 'A comprehensive fitness platform with workout tracking, diet plans, and progress monitoring.',
      tech: ['HTML5', 'CSS3', 'JavaScript', 'PHP', 'MySQL'],
      features: ['User Authentication', 'Workout Plans', 'Diet Tracking', 'Progress Analytics'],
      status: 'Completed',
      github: 'https://github.com/pc-daukiya/FitnessPlayGround-Website',
      demo: 'https://github.com/pc-daukiya/FitnessPlayGround-Website'
    },
    {
      id: 4,
      image: './assets/project-4.png',
      title: 'AgriTech Platform',
      description: 'Full-stack agriculture management system for farmers with real-time crop monitoring and market prices.',
      tech: ['HTML5', 'CSS3', 'JavaScript', 'PHP', 'MySQL', 'Node.js'],
      features: ['Crop Management', 'Market Integration', 'Weather Updates', 'Admin Dashboard'],
      status: 'Completed',
      github: 'https://github.com/pc-daukiya/Company-Agriculture-Website',
      demo: 'https://github.com/pc-daukiya/Company-Agriculture-Website'
    },
    {
      id: 5,
      image: './assets/project-5.png',
      title: 'Mood Music Player',
      description: 'Interactive music player that recommends songs based on your current mood with beautiful UI.',
      tech: ['HTML5', 'CSS3', 'JavaScript', 'API Integration'],
      features: ['Mood Detection', 'Music Recommendation', 'Playlist Management', 'Modern UI'],
      status: 'Completed',
      github: 'https://github.com/pc-daukiya/Mood-Song-Webpage',
      demo: 'https://github.com/pc-daukiya/Mood-Song-Webpage'
    },
    {
      id: 6,
      image: './assets/project-6.png',
      title: 'CRUD Data Manager',
      description: 'Professional data management system with full CRUD operations and advanced filtering capabilities.',
      tech: ['HTML5', 'CSS3', 'JavaScript', 'PHP', 'MySQL'],
      features: ['Create, Read, Update, Delete', 'Search & Filter', 'Data Export', 'Responsive UI'],
      status: 'Completed',
      github: 'https://github.com/pc-daukiya/Crud-Data-Layout',
      demo: 'https://github.com/pc-daukiya/Crud-Data-Layout'
    },
    {
      id: 7,
      image: './assets/project-7.jpeg',
      title: 'Portfolio Website',
      description: 'Modern and responsive portfolio website showcasing projects, skills, and professional experience with smooth animations.',
      tech: ['React', 'CSS3', 'JavaScript', 'Responsive Design'],
      features: ['Smooth Scrolling', 'Mobile Responsive', 'Project Showcase', 'Interactive UI'],
      status: 'Live',
      github: 'https://github.com/pc-daukiya',
      demo: 'https://prakash.trivanahospitality.com/'
    },
    {
      id: 8,
      image: './assets/project-8.jpeg',
      title: 'Trivana Hospitality Comapny Website',
      description: 'Professional corporate website for Trivana Hospitality showcasing luxury accommodations, services, and seamless booking experience.',
      tech: ['React', 'Tailwind CSS', 'JavaScript', 'Auth2.0', 'Spring Boot', 'MySQL'],
      features: ['Online Booking System', 'Room Gallery', 'Responsive Design', 'Contact Forms'],
      status: 'Live',
      github: 'https://github.com/pc-daukiya',
      demo: 'https://trivanahospitality.com/'
    },
    {
      id: 9,
      image: './assets/project-9.jpeg',
      title: 'Kesar Hotels',
      description: 'Complete hotel management system for client with gallery management, online bookings, room availability, and admin dashboard.',
      tech: ['React', 'Node.js', 'Express.js', 'MongoDB', 'Tailwind CSS', 'Cloudinary'],
      features: ['Gallery Management', 'Booking System', 'Admin Dashboard', 'Room Management', 'Payment Integration'],
      status: 'Live',
      github: 'https://github.com/pc-daukiya',
      demo: 'https://kesarhotels.com/'
    }
  ];

  const ProjectCard = ({ project }) => (
    <div className="details-container color-container">
      <div className="article-container">
        <img src={project.image} alt={project.title} className="project-img" />
        <div className="project-status-badge">{project.status}</div>
      </div>
      <div className="project-content">
        <h2 className="project-title-main outfit-bold">{project.title}</h2>
        <p className="project-description outfit-regular">{project.description}</p>
        
        <div className="tech-stack">
          {project.tech.map((tech, index) => (
            <span key={index} className="tech-badge">{tech}</span>
          ))}
        </div>
        
        <div className="project-features">
          <h3 className="features-title outfit-semibold">Key Features:</h3>
          <ul className="features-list">
            {project.features.slice(0, 3).map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
        
        <div className="btn-container">
          <button className="btn btn-color-1 project-btn" onClick={() => window.open(project.github, '_blank')}>
            <i className="fab fa-github"></i> Github
          </button>
          <button className="btn btn-color-2 project-btn" onClick={() => window.open(project.demo, '_blank')}>
            🚀 Live Demo
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <section id="projects">
      <p className="section__text__p1 outfit-semibold">Browse My Recent</p>
      <h1 className="title playfair-display-bold">Featured Projects</h1>
      <p className="projects-subtitle outfit-regular">
        Showcasing full-stack applications with real-world functionality
      </p>
      <div className="experience-details-container">
        <div className="about-containers projects-grid">
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
      <img 
        src="./assets/arrow.png" 
        alt="Arrow icon" 
        className="icon arrow" 
        onClick={() => window.location.href = '#contact'}
      />
    </section>
  );
}

export default Projects;
